import React, { useState, useEffect, useRef } from 'react';
import '../../../styles/components/columnChooser.scss';

import { DeepCopy } from '../shared/TableEventHelpers';
import OnHoverTooltip from './OnHoverTooltip';
import { useTranslation } from 'react-i18next';
import { CHOOSE_VISIBLE_COLUMNS_TOOLTIP, RESET } from '../../../i18n/keyConstants';

const ColumnChooser = ({ columns, hiddenColumns, onHiddenColumnChange, onReset }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation(['shared']);
    const dropdown = useRef();
    const dropdownToggle = useRef();

    useEffect(() => {
        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        };
    }, []);

    const handleClick = (e) => {
        if (dropdown.current && dropdownToggle.current) {
            if (!dropdown.current.contains(e.target) && !dropdownToggle.current.contains(e.target)) {
                setIsOpen(false);
            }
        }
    };

    const handleHiddenColumns = (columnName, isChecked) => {
        let tmpHiddenColumns = DeepCopy(hiddenColumns);
        if (isChecked) {
            tmpHiddenColumns = tmpHiddenColumns.filter((element) => {
                return element !== columnName;
            });
        } else {
            tmpHiddenColumns.push(columnName);
        }

        onHiddenColumnChange(tmpHiddenColumns);
    };

    const content = (
        <div id='column-chooser'>
            <div className='btn-group'>
                <OnHoverTooltip
                    labelClassNames='d-flex my-auto'
                    dataFor='column-chooser'
                    tooltipType='light'
                    tooltipPlace='top'
                    tooltipEffect='solid'>
                    <button
                        ref={dropdownToggle}
                        type='button'
                        className='btn btn-outline-secondary border-0 dropdown d-flex my-auto'
                        onClick={() => setIsOpen((isOpen) => !isOpen)}>
                        <span className='oi oi-eye'></span>
                    </button>
                    <span className='d-flex my-auto'>{t(CHOOSE_VISIBLE_COLUMNS_TOOLTIP)}</span>
                </OnHoverTooltip>
                {isOpen ? (
                    <ul className='dropdown-menu padding-bottom-none d-block' style={{ marginRight: 45 }} ref={dropdown}>
                        {columns.map((column) => {
                            const isChecked = hiddenColumns.indexOf(column.name) !== -1 ? false : true;
                            return (
                                <label
                                    htmlFor={column.name}
                                    className='dropdown-item dx-g-bs4-cursor-pointer checkbox-item margin-none padding-none margin-bottom-10px padding-left-50px  '
                                    key={column.title}>
                                    <input
                                        id={column.name}
                                        type='checkbox'
                                        checked={isChecked}
                                        onChange={() => handleHiddenColumns(column.name, !isChecked)}
                                        className='dx-g-bs4-cursor-pointer'
                                    />
                                    <span className='checkbox-item-checkmark'></span>
                                    {column.title}
                                </label>
                            );
                        })}
                        <div className='dropdown-divider margin-bottom-none'></div>
                        <li
                            className='dropdown-item margin-bottom-none dx-g-bs4-cursor-pointer text-center column-chooser-reset'
                            onClick={onReset}>
                            <span className='padding-left-10px'>{t(RESET)}</span>
                        </li>
                    </ul>
                ) : null}
            </div>
        </div>
    );
    return content;
};

export default ColumnChooser;
